export const domainConstants = {
  SUBMIT_DOMAIN_REQUEST: 'SUBMIT_DOMAIN_REQUEST',
  SUBMIT_DOMAIN_SUCCESS: 'SUBMIT_DOMAIN_SUCCESS',
  SUBMIT_DOMAIN_UNAVAILABLE: 'SUBMIT_DOMAIN_UNAVAILABLE',
  SUBMIT_DOMAIN_FAILURE: 'SUBMIT_DOMAIN_FAILURE',
}